import { RemoteConfigVariables, GymEnvironment } from 'fitbeat.models';
import { homePlanEnvironmentMapForIAP, homePlanEnvironmentMapForInitialUserSignup } from 'fitbeat.models';

export const remoteConfigDefaults = {
    [RemoteConfigVariables.welcome_screen_version]: 'A',
    [RemoteConfigVariables.signup_auth_screen_version]: 'A',
    [RemoteConfigVariables.onboarding_screen_version]: 'A',
    [RemoteConfigVariables.signup_post_auth_action]: 'PAYWALL',
    [RemoteConfigVariables.signup_screen_version]: 'A',
    [RemoteConfigVariables.welcome_screen_sub_heading]: 'Personalised workouts, nutrition & goal tracking.',
    [RemoteConfigVariables.welcome_screen_heading]: '',
    [RemoteConfigVariables.welcome_screen_register_button]: 'Sign Up to 7-Day Free Trial',
    [RemoteConfigVariables.welcome_screen_login_button]: 'Already a Member? Log in',
    [RemoteConfigVariables.create_account_screen_heading]: 'CREATE ACCOUNT TO START FREE TRIAL',
    [RemoteConfigVariables.create_account_screen_sub_heading]: 'No subscription or credit card required',
    [RemoteConfigVariables.in_app_purchase_screen_product_description]: 'Cancel your membership at any time.',
    [RemoteConfigVariables.in_app_purchase_screen_benefit]: 'Experience personalised workouts, nutrition and goal tracking.',
    [RemoteConfigVariables.in_app_purchase_close_modal_sub_header]: 'Tap the Join Now button to activate your membership.',
    [RemoteConfigVariables.paywall_heading_text]: 'GET FULL MEMBER ACCESS',
    [RemoteConfigVariables.paywall_payment_text]: 'only ${this.price}/month',
    [RemoteConfigVariables.learn_more_about_nutrition_button_visible]: 'false',

    [`${RemoteConfigVariables.free_trial_days}_${GymEnvironment.Staging}`]: '7',
    [`${RemoteConfigVariables.free_trial_days}_${GymEnvironment.Production}`]: '7',

    [`${RemoteConfigVariables.iap_hub_product_id_fitillion}_${GymEnvironment.Staging}`]:
        homePlanEnvironmentMapForIAP[GymEnvironment.Staging],
    [`${RemoteConfigVariables.iap_hub_product_id_fitillion}_${GymEnvironment.Production}`]:
        homePlanEnvironmentMapForIAP[GymEnvironment.Production],

    [RemoteConfigVariables.smart_scale_shop_url]: 'https://fitillion.com/product/smart-scale/',
    [RemoteConfigVariables.tigernovo_heart_rate_shop_url]: 'https://fitillion.com/product/heart-rate-monitor/',
    [`${RemoteConfigVariables.signup_initial_plan_id}_${GymEnvironment.Staging}`]:
        homePlanEnvironmentMapForInitialUserSignup[GymEnvironment.Staging][1],
    [`${RemoteConfigVariables.signup_initial_plan_id}_${GymEnvironment.Production}`]:
        homePlanEnvironmentMapForInitialUserSignup[GymEnvironment.Production][1],

    [RemoteConfigVariables.smart_scale_shop_url]: 'https://fitillion.com/product/smart-scale/',
    [RemoteConfigVariables.enable_first_time_booking_instant_workout]: 'enable',
};
